var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85749 7.47416H10.9525V9.01582C11.3983 8.12916 12.5417 7.33249 14.2592 7.33249C17.5517 7.33249 18.3333 9.09749 18.3333 12.3358V18.3333H15V13.0733C15 11.2292 14.5542 10.1892 13.4192 10.1892C11.845 10.1892 11.1908 11.31 11.1908 13.0725V18.3333H7.85749V7.47416ZM2.14166 18.1917H5.47499V7.33249H2.14166V18.1917ZM5.95249 3.79166C5.95261 4.07105 5.8972 4.34769 5.78948 4.60548C5.68175 4.86327 5.52387 5.09708 5.32499 5.29332C4.92199 5.69384 4.3765 5.91803 3.80832 5.91666C3.24115 5.91628 2.69692 5.69266 2.29332 5.29416C2.09517 5.09725 1.93781 4.86318 1.83028 4.60535C1.72274 4.34752 1.66714 4.07101 1.66666 3.79166C1.66666 3.22749 1.89166 2.68749 2.29416 2.28916C2.69739 1.89012 3.24186 1.66641 3.80916 1.66666C4.37749 1.66666 4.92249 1.89082 5.32499 2.28916C5.72666 2.68749 5.95249 3.22749 5.95249 3.79166Z",
    fill: "#838390"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.3ed8c2679f6c8f40084218cff9ac7950.svg";
export { ForwardRef as ReactComponent };